// Generated by DesignToCode

import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-office-situation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './office-situation.html',
})
export class OfficeSituation {
  // Inputs
  public title = input<string>('Office Situation');
  public items = input<string[]>([
    'We’ve been remote-first since day one, long before it became the norm.',
    'Meeting in person twice a week works best for us. It helps us stay connected and collaborate better.',
    'Throughout the year, all Engineering, Design, Product, and Business teams gather for Townhall sessions where we share what we’ve been working on to see the bigger picture and ensure our alignment to our vision.',
  ]);

  // Computed: split items into left (first 2) and right (remaining) for desktop two-column layout
  public desktopLeftItems = computed<string[]>(() => this.items().slice(0, 2));
  public desktopRightItems = computed<string[]>(() => this.items().slice(2));
}
